{
	"title": "Creează declarație",
	"backLinkToMaterialDetailsTitle": "Înapoi la detaliile materialului",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Înapoi la {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Înapoi la gestionarea declarațiilor",
	"steps": {
		"firstStep": {
			"title": "Pasul 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Pasul 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Pasul 3",
			"label": "3"
		}
	}
}
